import React, { Component } from "react";
import { DKLabel, DKButton, DKIcons } from "deskera-ui-library";
import {
    COLUMN_CODE,
    TableManger,
    TABLES,
} from "../../../managers/TableManger";
import Table from "../../../services/table";
import TableDataParser from "../../../Helper/TableDataParser";
import { getDashboardWidgetLoading } from "../../dashboard/Dashboard";
import FormManager from "../../forms/FormManager.js";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";

interface IFormsCardProps {
    onCountUpdated: (count: number) => void;
}
interface IFormsCardState {
    data: any[];
    showLoading: boolean;
}
class JobFormCard extends Component<IFormsCardProps, IFormsCardState> {
    columnsIds = {
        name: "",
        link: "",
        thumbnail: "",
    };
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            showLoading: false,
        };
    }
    componentDidMount() {
        this.setColumnsIds();
        this.fetchRecords();
    }
    render() {
        return (
            <>
                {this.state.showLoading && getDashboardWidgetLoading()}
                {
                    <>
                        {!this.state.showLoading && this.state.data.length !== 0 && (
                            <>
                                <DKLabel
                                    text="Recently added"
                                    className="text-gray fw-m mb-r"
                                />
                                {this.state.data.map((record) => this.getRow(record))}
                            </>
                        )}
                    </>
                }
                {!this.state.showLoading &&
                    this.state.data.length === 0 &&
                    this.getEmptyState()}
            </>
        );
    }

    getRow(record) {
        return (
            <div className="row mt-r mb-r justify-content-between">
                <div className="column" style={{ maxWidth: "100%" }}>
                    <DKLabel
                        text={`${record[this.columnsIds.name]}`}
                        className="fw-m row"
                    />
                    {record[this.columnsIds.link] ? (
                        <DKLabel
                            className="fs-r text-align-left mt-xs cursor-hand row data-link-wrapper word-break-all"
                            text={`<a style="color: rgb(0, 99, 225); text-decoration: none; font-size: 12px" target="_blank" href=${record[this.columnsIds.link]
                                }>${record[this.columnsIds.link]}</a>`}
                        />
                    ) : (
                        <DKLabel
                            className={`p-v-xs p-h-s border-radius-s mt-s data-grid-badge-color-5`}
                            text={"Draft"}
                        />
                    )}
                </div>
                <DKButton
                    icon={DKIcons.ic_edit}
                    className="border-m  ml-r"
                    style={{ opacity: 0.6 }}
                    onClick={() => {
                        let data = record;
                        let data_formatted = { data: null, id: null };
                        data_formatted.data = {
                            _id: data.id,
                            cells: data,
                        };
                        data_formatted.id = data.id;

                        FormManager.setFormData(data_formatted);
                        RouteManager.navigateToPage(
                            PAGE_ROUTES.FORM_BUILDER + "/" + data.id
                        );
                    }}
                />
            </div>
        );
    }

    fetchRecords() {
        const formTableId = TableManger.getTableId(TABLES.JOB_FORMS);
        Table.getRecordsByPage({ pageNo: 1, pageSize: 10 }, null, formTableId).then(
            (res: any) => {
                if (this.props.onCountUpdated)
                    this.props.onCountUpdated(res.totalCount);
                this.setState({
                    data: TableDataParser.parseRowData(res.data, TABLES.JOB_FORMS),
                    showLoading: false,
                });
            }
        );
    }

    setColumnsIds = () => {
        this.columnsIds.name = TableManger.getColumnId(
            TABLES.JOB_FORMS,
            COLUMN_CODE.JOB_FORMS.NAME
        );
        this.columnsIds.link = TableManger.getColumnId(
            TABLES.JOB_FORMS,
            COLUMN_CODE.JOB_FORMS.DOMAIN
        );
        this.columnsIds.thumbnail = TableManger.getColumnId(
            TABLES.JOB_FORMS,
            COLUMN_CODE.JOB_FORMS.THUMBNAIL
        );
    };
    getEmptyState = () => {
        return (
            <div className="column parent-width parent-height align-items-center justify-content-center">
                <DKLabel text="No data found" className="fw-m fs-m text-gray" />
                <DKLabel text="Create and send form here" className="text-gray mt-xs" />
            </div>
        );
    };
}

export default JobFormCard;
